import { AssessmentsData } from "@pandas/http-client";
import { AssessmentComponent, DeviceType } from "./assessmentComponents/componentTypes";
import { AssessmentEngine } from "./assessmentEngine";
import { AssessmentEngineConfig } from "./assessmentEngineConfig";
import { getAssessmentTypeComponents, setActors, setPlatformApi } from "./services/platform/platform-service";
import { AssessmentsEntry } from "./types";

let _smartwatchComponents: AssessmentsData;
let _deviceComponents: AssessmentsData;
let _config: AssessmentEngineConfig;
async function GetCachedComponents(deviceType: DeviceType): Promise<AssessmentsData> {
	if (deviceType === "smartwatch") {
		if (!_smartwatchComponents)
			_smartwatchComponents = await getAssessmentTypeComponents(deviceType, _config.componentVersion);
		return _smartwatchComponents;
	} else {
		if (!_deviceComponents) _deviceComponents = await getAssessmentTypeComponents(deviceType, _config.componentVersion);
		return _deviceComponents;
	}
}
function MapAssessmentsFromPlatform(assessments: AssessmentsData) {
	const mappedAssessments = Object.keys(assessments).map<AssessmentsEntry>((key) => ({
		id: assessments[key]!.id,
		components: assessments[key]!.components,
		key: key as AssessmentComponent,
	}));
	return mappedAssessments;
}
function GetAssessmentEngineInstance(
	assessments: AssessmentsData,
	filterComponents: AssessmentComponent[] = [],
): AssessmentEngine {
	let mappedAssessments = MapAssessmentsFromPlatform(assessments);
	if (filterComponents.length > 0)
		mappedAssessments = mappedAssessments.filter((a) => filterComponents.includes(a.key));
	return new AssessmentEngine(mappedAssessments, _config.componentVersion);
}
export async function InitAssessmentEngine(
	deviceType: DeviceType,
	filterComponents: AssessmentComponent[] = [],
): Promise<AssessmentEngine> {
	if (!_config)
		throw new Error(
			"Assessment engine configuration is not found, call Configure once before accessing any factory methods",
		);
	const assessments = _config.enableCache
		? await GetCachedComponents(deviceType)
		: await getAssessmentTypeComponents(deviceType, _config.componentVersion);
	return GetAssessmentEngineInstance(assessments, filterComponents);
}
export function ConfigureAssessmentEngine(configuration: AssessmentEngineConfig) {
	setPlatformApi(configuration.platformApi);
	setActors(configuration.actor);
	_config = configuration;
}
